export const discordJumpLinkMap = {
    'en': 'https://discord.gg/7xEtgxKjWK',
    'de': 'https://discord.gg/7xEtgxKjWK',
    'fr': 'https://discord.gg/7xEtgxKjWK',
}
